import React from "react";

function SortedBy({ filter, setFilter, togglePopup }) {
  const PreReadbtns = document.querySelectorAll(".AssDess");
  PreReadbtns.forEach((btnElCM) => {
    btnElCM.addEventListener("click", () => {
      document
        .querySelector(".sortByFocused")
        ?.classList.remove("sortByFocused");
      btnElCM.classList.add("sortByFocused");
    });
  });
  return (
    <div className="sortByContainer p-3"
      style={{ position: "absolute", top: "50px", right: "0" }}
    >
      <div className="text-[10px] font-semibold">DATE</div>
      <button
        onClick={() => {
          setFilter({ ...filter, sortBy: 1 });
          togglePopup();
        }}
        className={`${filter.sortBy === 1 && "sortByFocused"} AssDess mt-2`}
      >
        Ascending
      </button>
      <button
        onClick={() => {
          setFilter({ ...filter, sortBy: -1 });
          togglePopup();
        }}
        className={`${filter.sortBy === -1 && "sortByFocused"} AssDess mt-2`}
      >
        Descending
      </button>
    </div>
  );
}

export default SortedBy;
